import React, { useState, useEffect } from "react";
import TreeItem from "./TreeItem";
import { useSelector } from "react-redux";
import { IAppState } from "../../types/stores/index";

type Props = {
    collapsed?: boolean;
    defaultCollapsed: boolean;
    nodeLabel: React.ReactNode;
    itemClassName?: string;
    children: React.ReactElement;
    onUpdate?: () => void;
    onToggle?: () => void;
    /** Invoked when the folder becomes visible (starts expanded or user opens it). */
    onExpand?: () => void;
    headerMap?: ((headerTreeItem: any) => JSX.Element) | null;
};

const TreeView: React.FC<Props> = ({
    defaultCollapsed,
    collapsed,
    nodeLabel,
    itemClassName,
    children,
    onUpdate,
    onToggle,
    onExpand,
    headerMap,
}: Props) => {
    //const useLazyLoading = useSelector((state: IAppState) => {
    //    const features = state.session?.enabledFeatures ?? [];
    //    return features.includes("lazy-loading-fieldtree");
    //});
    const initialCollapsed = typeof collapsed == "boolean" ? collapsed : defaultCollapsed;
    const [collapseState, setCollapseState] = useState(initialCollapsed);
    const pathname = useSelector(
        (state: IAppState) => state.router && state.router.location && state.router.location.pathname
    );

    const handleClick = () => {
        const wasCollapsed = collapseState;
        const next = !collapseState;
        setCollapseState(next);
        if (onToggle) onToggle();
        if (wasCollapsed && !next && onExpand) {
            onExpand();
        }
    };

    useEffect(() => {
        if (onUpdate) {
            onUpdate();
        }

        if (typeof collapsed === "boolean") {
            setCollapseState(collapsed);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onUpdate, defaultCollapsed, collapsed]);

    let containerClassName = "tree-view_children";
    if (collapseState) {
        containerClassName += " tree-view_children-collapsed";
    }

    let folderIcon = <i className="proton-icon proton-icon-folder-open" />;
    if (collapseState) {
        folderIcon = <i className="proton-icon proton-icon-folder-closed" />;
    }

    if (
        pathname &&
        (pathname.includes("flows") ||
            pathname.includes("schedules") ||
            pathname.includes("layouts") ||
            pathname.includes("/admin/fields/edit") ||
            pathname.includes("/admin/restricted-fields"))
    ) {
        folderIcon = (
            <i className="material-icons" style={{ position: "relative", fontSize: "2em" }}>
                folder_open
            </i>
        );
        if (collapseState) {
            folderIcon = (
                <i className="material-icons" style={{ position: "relative", fontSize: "2em" }}>
                    folder
                </i>
            );
        }
    }

    let headerTreeItem = (
        <TreeItem staticClasses={"tree-view_header " + itemClassName || ""} handleClick={handleClick}>
            {folderIcon}
            <span className="tree-header-label">{nodeLabel}</span>
        </TreeItem>
    );

    if (headerMap) {
        headerTreeItem = headerMap(headerTreeItem);
    }

    return (
        <div className="tree-view">
            {headerTreeItem}
            <div className={containerClassName}>{collapseState ? null : children}</div>
        </div>
    );
};

export default TreeView;
